module.exports = __webpack_public_path__ + "48264d44ca60d7bf681a4415e33ff40e.svg";